export default {
  forgot_password_confirm: {
    title: 'Đặt lại mật khẩu',
    required_code: 'Mã xác nhận là bắt buộc',
    required_password: 'Mật khẩu là bắt buộc',
    max_length_16: 'Mật khẩu phải bao gồm 8-16 ký tự',
    // no_blank: "",
    no_password_match: 'Mật khẩu không khớp',
    reset_password: 'Đặt lại mật khẩu',
    caution: 'Xin đừng đóng cửa sổ này vội',
    double_check_text: '@:login.double_check_text',
    password_reset_text: 'Email đã được gửi đến địa chỉ email này. Vui lòng nhập mã xác minh được gửi tới email của bạn dưới đây.',
    verification_code: 'Mã xác minh',
    mail_send_code: 'Mã xác nhận đã gửi trong email',
    password: 'Mật khẩu',
    new_password: 'Mật khẩu mới',
    password_display: 'Hiện mật khẩu',
    password_no_display: 'Ẩn mật khẩu',
    password_check: 'Xác nhận mật khẩu',
    submit: 'Xác nhận',
  },
}
